module.exports = __webpack_public_path__ + "media/admin_theme/logo-dark-669b1502.png";